import { getTsPharmacyClient } from '@montugroup/circuit-shared/api/pharmacy.client';

const client = getTsPharmacyClient();
const { useQuery, keys } = client.getPharmacyOnboarding;

export function useGetPharmacyOnboarding({ token }: { token: string | undefined }) {
  return useQuery({
    queryKey: [...keys, token],
    queryData: {
      params: {
        token: encodeURIComponent(token ?? ''),
      },
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(token),
  });
}
